export const getAuthHeader = (user) => {
  return user ? { Authorization: `${user.token_type || 'Bearer'} ${user.access_token}` } : {};
};
